import "core-js/modules/es.array.concat.js";
import service from './service';
import md5 from '../utils/md5';
var apk = process.env.VUE_APP_MAIA_APPKEY;
var srk = '693c9462-de07-4d50-a80d-d3b7df744585';
/**
 * 获取麦芽平台在线配置信息
 * @param {String} paramKey 查询的Key
 * @returns
 */

export function getMaiaOnlineParams() {
  var paramKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var timestamp = new Date().getTime();
  var signTemp = "appKey=".concat(apk, "&paramKey=").concat(paramKey, "&timestamp=").concat(timestamp, "&secretKey=").concat(srk);
  var sign = md5(signTemp).toUpperCase();
  var params = {
    appKey: apk,
    paramKey: paramKey,
    timestamp: timestamp,
    sign: sign
  };
  return service({
    timeout: 5000,
    withCredentials: true,
    headers: {
      'X-Gaia-Api-Key': '490be721-2939-4bfd-9301-03566de7451c'
    },
    baseURL: 'https://openapi.longhu.net/maiaplat-prod/param',
    url: '/getByMobile',
    // 改动的话请同步responseIntercepter里的白名单配置
    methods: 'get',
    params: params
  });
}